import { useCallback, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { toast } from 'material-react-toastify';

export const useUserEmailSearch = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const [searchEmail, setSearchEmail] = useState(() => searchParams.get('email') || '');
  const [activeEmail, setActiveEmail] = useState<string | null>(() => searchParams.get('email'));

  useEffect(() => {
    const emailFromUrl = searchParams.get('email');
    if (!emailFromUrl) {
      setSearchEmail('');
      setActiveEmail(null);
      return;
    }

    const decodedEmail = decodeURIComponent(emailFromUrl);
    setSearchEmail(decodedEmail);
    setActiveEmail(decodedEmail);
  }, [searchParams]);

  const handleSearch = useCallback(() => {
    const trimmedEmail = searchEmail.trim();
    if (!trimmedEmail) {
      toast.error('Please enter an email address');
      return;
    }

    setActiveEmail(trimmedEmail);
    setSearchParams({ email: trimmedEmail });
  }, [searchEmail, setSearchParams]);

  const handleClearField = useCallback(() => {
    setSearchEmail('');
    setActiveEmail(null);
    setSearchParams({});
  }, [setSearchParams]);

  const handleKeyUp = useCallback(
    (e: React.KeyboardEvent) => {
      if (e.key === 'Enter') {
        handleSearch();
      }
    },
    [handleSearch],
  );

  return {
    activeEmail,
    searchEmail,
    setSearchEmail,
    handleSearch,
    handleClearField,
    handleKeyUp,
  };
};
